import WidgetAjax from './../widget/WidgetAjax';

import data from './data.json';

let TYPE = process.env.TYPE_ENV;

export default class Config {

    static getBasePath() {

        //测试环境
        // const basePath = "http://218.26.73.114:18082/ApplicantAPI";

        // 正式环境
        const basePath = "https://service.pinzhunzhun.com/ApplicantAPI"; 

        return basePath;
    }


    // 前端路由 basename(/recruit) 用于构建站内绝对路径(如 Footer 中的证照链接)
    static getBaseRoutePath() {
        return "/recruit";
        // return "/recruitment-applicant-web";
    }


    static getFilePath() {

        const basePath = "/recruitment/media/";
        // const basePath = "http://218.26.73.114:18121/recruitment/media/";

        return basePath;
    }

    static getTemporaryFilePath() {

        const basePath = "/recruitment/";

        // const basePath = "http://218.26.73.114:18121/recruitment/";

        return basePath;
    }

    //微信应用名称
    static getApplication() {

        const application = "woa|pzz|SP";

        return application;
    }

  static getEnterpriseUrl() {

        const basePath = "https://www.pinzhunzhun.com";

        return basePath;
    }



    static getCareerUrl() {

        // const basePath = "http://218.26.73.114:18121/recruitment-applicant-career-web";
        const basePath = "https://www.pinzhunzhun.com/career";

        return basePath;
    }


    static getDBID() {
        const DBID = undefined;
        return DBID;
    }

    static getMapName() {
        return "110105";
    }

    static getEncryptyType() {
        return "MD5";
    }

    static isShowHeaderArea() {
        return false;
    }

    static getSystemTitle() {

        if (data && data[TYPE]) {
            return data[TYPE].title;
        }
        else {
            return "高校毕业生就业服务智能体平台";
        }
    }

    static getSystemType() {
        return "sso"; // 线上
        // return "local"; // 线下
    }

    static getAMapPath() {

        return "https://apis.map.qq.com/ws/location/v1/ip";
    }

    static getAMapKey() {

        return "MMVBZ-UCEKI-DFKGG-UC3DX-7ATT2-R5F3S";
    }

    // 是否通过接口来请求页面数据
    static isInterface() {

        let isInterface = false;

        return isInterface;
    }

    static getCustomerPhone() {
        if (data && data[TYPE]) {
            return data[TYPE].customerPhone;
        }
        else {
            return "";
        }

    }

    static getSourcePath() {
        return TYPE || "pinzhunzhun";
    }

    static getLicenseContent() {
        if (data && data[TYPE]) {
            return data[TYPE].licenseContent;
        }
        else {
            return "";
        }
    }

    static getSystemFavicon() {
        if (data && data[TYPE]) {
            return data[TYPE].systemFavicon;
        }
        else {
            return "";
        }
    }

    static getClassComponent() {
        if (data && data[TYPE]) {
            return data[TYPE].classComponent;
        }
        else {
            return "";
        }
    }




}


